import { ConfigEntity } from '@/typings';
import { getPage } from '@/utils/util';
import { request } from '@umijs/max';

export async function queryConfigs(pars: any) {
    const res = await getPage('/api/config/list', pars);
    return res;
}

export async function getConfig(id: number) {
    return request<ConfigEntity>('/api/config/' + id, {
        method: 'GET',
    });
}

export async function addConfig(data: ConfigEntity) {
    return request<ConfigEntity>('/api/config', {
        method: 'POST',
        data
    });
}
export async function modifyConfig(data: ConfigEntity) {
    return request<ConfigEntity>('/api/config', {
        method: 'PUT',
        data
    });
}

export async function deleteConfig(id: number) {
    return request<ConfigEntity>('/api/config/' + id, {
        method: 'DELETE',
    });
}

export async function getConfigByCode(code: string) {
    return request<ConfigEntity>('/api/config/byCode/' + code, {
        method: 'GET',
    });
}

